const t = "group group min-h-[42px] relative rounded-lg py-2.5 font-medium text-sm main-transition-colors focus-ring whitespace-nowrap [&>*]:font-medium [&>*]:font-inter font-inter cursor-pointer", e = "flex items-center justify-center gap-2";
export {
  t as BASE_CLASS_NAME,
  e as BASE_FLEX_CLASS_NAME
};
